import {css} from '@yandex-delivery/blocks/theme/css'
import {theme} from '@yandex-delivery/blocks/theme/theme'
import heartGray from 'src/shared/assets/heartGray.svg'
import heartYellow from 'src/shared/assets/heartYellow.svg'

const COMPLIMENT_ICON_SIZE = 72
const COMPLIMENT_PLACEHOLDER_SIZE = 51

export const classes = {
  root: css`
    cursor: pointer;
    margin: 0 ${theme.spacing(1)}px;
    width: 25%;
  `,
  label: css`
    text-align: center;
    display: block;
    width: 100%;
    color: var(--colorScheme-textMinor, #9e9b98);

    :global(html[data-theme='dark']) & {
      color: var(--colorScheme-textMinor, rgba(224, 222, 218, 0.5));
    }
  `,
  labelSelected: css`
    color: var(--colorScheme-text, #21201f);

    :global(html[data-theme='dark']) & {
      color: var(--colorScheme-text, #e0deda);
    }
  `,
  imageDefault: css`
    width: ${COMPLIMENT_ICON_SIZE}px;
    height: ${COMPLIMENT_ICON_SIZE}px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      content: '';
      width: ${COMPLIMENT_PLACEHOLDER_SIZE}px;
      height: ${COMPLIMENT_PLACEHOLDER_SIZE}px;
      background: url('${heartGray}') no-repeat 50% calc(50% + 2px) #f1efed;
      border-radius: 50%;
    }
    > img {
      display: none;
      margin: auto;
      height: 100%;
    }

    :global(html[data-theme='dark']) & {
      &::before {
        background: url('${heartGray}') no-repeat 50% calc(50% + 2px) #302f2d;
      }
    }
  `,
  imageDefaultSelected: css`
    &::before {
      background-image: url('${heartYellow}');
      background-color: transparent;
    }
  `,
  imageCustom: css`
    &::before {
      display: none;
    }
  `,
  visible: css`
    display: block !important;
  `,
}
